export default __webpack_public_path__ + "static/media/cover2.92a6c618.png";